import Layout from '@/views/stock/Layout.vue';

export default {
    path: '/stock',
    component: Layout,
    children: [
        { path: 'list', component: () => import('@/views/stock/StockList.vue') },
        { path: 'add', component: () => import('@/views/stock/AddStock.vue') },
        { path: 'view', component: () => import('@/views/stock/ViewStock.vue') },
        { path: 'analysis', component: () => import('@/views/stock/StockAnalysis.vue') },
        { path: 'stock-transaction', component: () => import('@/views/stock/StockTransaction.vue') },
        { path: 'dividend-report', component: () => import('@/views/stock/Dividend/Report.vue') },
        { path: 'add-dividend', component: () => import('@/views/stock/Dividend/AddDividend.vue') },
        { path: 'import-dividend', component: () => import('@/views/stock/Dividend/ImportDividend.vue') },
        { path: 'auto-dividend', component: () => import('@/views/stock/Dividend/AutoDividend.vue') },
        { path: 'dividend-analysis', component: () => import('@/views/stock/Dividend/Analysis.vue') },
        { path: 'tax-planner', component: () => import('@/views/stock/TaxPlanner.vue') },
    ]
};
